<template>
    <div>
        <div class="mt-2">
            <h3 v-if="issue_type == 'highway'">Corrective Maintenance</h3>
            <h3 v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance</h3>
            <h3 v-else-if="issue_type == 'major_maintenance'">Major Maintenance</h3>
            <h3 v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance</h3>
            <h3 v-else-if="issue_type == 'road_user_accident'">Road User Accident Issue</h3>
            <h3 v-else-if="issue_type == 'occupational'">Occupational Accident Issue</h3>
            <h3 v-else-if="issue_type == 'hazard'">Hazard Accident Issue</h3>
            <h3 v-else-if="issue_type == 'dead_animal_debris_removal'">Dead Animal Debris Removal Issue</h3>
            <h3 v-else-if="issue_type == 'vehicle_breakdown'">Vehicle Breakdown Issue</h3>
            <h3 v-else-if="issue_type == 'traffic_violation'">Traffic Violation Issue</h3>
            <h3 v-else-if="issue_type == 'unauthorised_parking'">Unauthorised Parking Issue</h3>
            <h3 v-else-if="issue_type == 'unauthorised_access'">Unauthorised Access Issue</h3>
            <h3 v-else-if="issue_type == 'unauthorised_media_cut'">Unauthorised Median Cut Issue</h3>
            <h3 v-else-if="issue_type == 'material_damage'">Material Damage Issue</h3>
            <h3 v-else-if="issue_type == 'other'">Other Issue</h3>
            <h3 v-else-if="issue_type == 'enroachment_row'">Enroachment Row Issue</h3>
            <h3 v-else-if="issue_type === null">Issue List</h3>
        </div>
        <vs-row v-if="issue_type">
            <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 mb-base">
                <router-link :to="{name: 'issues-new', params: {issue_type: issue_type}}">
                    <vs-button color="primary" type="filled" class="w-full">
                        Create Issue
                    </vs-button>
                </router-link>
            </vs-col>
        </vs-row>
        <template v-if="results && results.length">
            <vx-card v-for="(item, index) in results" :key="index">
                <div class="issue-card p-4 mb-3" slot="no-body" v-if="item.data">
                    <vs-row class="m-0 p-0">
                        <vs-col class="px-0 pr-1" vs-xs="11" vs-sm="11" vs-lg="11">
                            <h4 class="m-0">Issue # {{ item.id }}</h4>
                            <small class="block">
                                <span class="font-bold"> Upload Status: {{ item.status }}</span>
                            </small>
                            <small class="block">
                                <span class="font-bold"><FormatText :text="issue_type" format="select" :kwargs="display_options" /> :</span> {{ issue_category(item.data) }}
                            </small>
                            <small class="block">
                                <span class="font-bold">Created at:</span> <FormatText :text="item.timestamp" format="datetime" />
                            </small>
                        </vs-col>
                        <vs-col class="px-1 text-right flex" vs-align="center" vs-xs="1" vs-sm="1" vs-lg="1">
                            <template v-if="item.status == 'draft'">
                                <router-link :to="{name: 'cache-issue-edit', params: {issue_type: issue_type, issue_id: item.id}}">
                                    <vs-button type="flat" class="px-1 py-1" size="large" color="primary">
                                        <font-awesome-icon :icon="rightIcon" />
                                    </vs-button>
                                </router-link>
                            </template>
                            <template v-else>
                                <router-link :to="{name: 'cache-issue-view', params: {issue_type: issue_type, issue_id: item.id}}">
                                    <vs-button type="flat" class="px-1 py-1" size="large" color="primary">
                                        <font-awesome-icon :icon="rightIcon" />
                                    </vs-button>
                                </router-link>
                            </template>
                        </vs-col>
                    </vs-row>
                </div>
            </vx-card>
        </template>
        <template v-else>
            <vx-card>
                <h4 class="text-center">Data Not Available!</h4>
            </vx-card>
        </template>
    </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
export default {
    data() {
        return {

            issue_type: this.$route.params.issue_type,
            results: [],
            api_errors: null,

            issue_type_options: [
                {label: 'Routine Maintenance', value: 'routine_maintenance'},
                {label: 'Electrical Maintenance', value: 'electrical_maintenance'},
                {label: 'Major Maintenance', value: 'major_maintenance'},
                {label: 'Corrective Maintenance', value: 'highway'},
                {label: 'Road User Accident', value: 'road_user_accident'},
                {label: 'Occupational', value: 'occupational'},
                {label: 'Hazard', value: 'hazard'},
                {label: 'Vehicle Breakdown', value: 'vehicle_breakdown'},
                {label: 'Traffic Violation', value: 'traffic_violation'},
                {label: 'Unauthorised Parking', value: 'unauthorised_parking'},
                {label: 'Unauthorised Access', value: 'unauthorised_access'},
                {label: 'Unauthorised Median Cut', value: 'unauthorised_media_cut'},
                {label: 'Material Damage', value: 'material_damage'},
                {label: 'Other', value: 'other'},
                {label: 'Dead Animal Debris Removal', value: 'dead_animal_debris_removal'},
                {label: 'Enroachment Row', value: 'enroachment_row'},
            ],

            display_options: [
                {label: 'Issue Category', value: 'highway'},
                {label: 'Issue Category', value: 'routine_maintenance'},
                {label: 'Issue Category', value: 'major_maintenance'},
                {label: 'Issue Category', value: 'electrical_maintenance'},
                {label: 'Nature of Accident', value: 'road_user_accident'},
                {label: 'Accident Classification', value: 'occupational'},
                {label: 'Issue Category', value: 'hazard'},
                {label: 'Type of Vehicle', value: 'vehicle_breakdown'},
                {label: 'Type of Vehicle', value: 'traffic_violation'},
                {label: 'Type of Vehicle', value: 'unauthorised_parking'},
                {label: 'Material Damage', value: 'material_damage'},
                {label: 'Incident Details', value: 'other'},
                {label: 'Type of Enroachment', value: 'enroachment_row'},
                {label: 'Action Taken', value: 'unauthorised_access'},
                {label: 'Action Taken', value: 'unauthorised_media_cut'},
                {label: 'Action Taken', value: 'dead_animal_debris_removal'},

            ],
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        issue_type(newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        "$route.params.issue_type"(newV, oldV) {
            this.issue_type = newV
        }
    },
    computed: {
        rightIcon: () => faChevronRight,
    },
    methods: {
        init() {
            this.load_data()
        },
        async load_data() {
            if (!this.issue_type) {
                this.api_errors = {
                    'issue_type': ['Issue is required.',]
                }

            } else {
                this.api_errors = {}
                let key = `issues__${this.issue_type}`
                let res = await this.$ionicStorage.get(key)
                
                let data = JSON.parse(res)

                if (data && this.$route.query.is_failed) {
                    this.results = data.filter(obj => obj.status == 'draft')
                } else {
                    this.results = data
                }
            }

        },
        issue_category (item) {

            if (this.issue_type == 'highway') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'routine_maintenance') {
                return item['data']['category']['name']

            }  else if (this.issue_type == 'major_maintenance') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'electrical_maintenance') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'road_user_accident') {
                return item['data'] && item['data']['nature_of_accident'] ? item['data']['nature_of_accident']['name'] : null
                
            } else if (this.issue_type == 'occupational') {
                return item['data']['accident_classification']['name']
                
            } else if (this.issue_type == 'hazard') {
                return item['data']['category']['name']
                
            } else if (this.issue_type == 'vehicle_breakdown') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'traffic_violation') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'unauthorised_parking') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'material_damage') {
                return item['data']['material_damaged']

            } else if (this.issue_type == 'other') {
                return item['data']['incident']

            }  else if (this.issue_type == 'enroachment_row') {
                return item['data']['enroachment_type']['name']

            }  else if (this.issue_type == 'unauthorised_access') {
                return item['data']['action_taken']

            }  else if (this.issue_type == 'unauthorised_media_cut') {
                return item['data']['action_taken']

            }  else if (this.issue_type == 'dead_animal_debris_removal') {
                return item['data']['action_taken']

            }
        }
    }
}
</script>